import TableNoDataImg from '@/assets/images/svg/TableNoData';
import COLORS from '@/constants/colors';
import { Typography } from '@mui/material';
import Stack from '@mui/material/Stack';

export default function TableNoData({ message }: { message?: string }) {
  return (
    <Stack alignItems="center" sx={{ p: '40px' }}>
      <TableNoDataImg />
      {message && (
        <Typography
          sx={{
            fontSize: '20px',
            fontWeight: 600,
            color: COLORS.gray_3,
            mt: '8px',
            textAlign: 'center',
          }}
        >
          {message}
        </Typography>
      )}
    </Stack>
  );
}
